import React, { Fragment } from 'react';
import { differenceInDays } from 'date-fns';

import { LifecycleChangeType } from 'app/entities/VersionLifecycle/types';

import Done from './Done';
import Error from '../Error';
import Progress from './Progress';

type Props = {
  error?: { messages: string[] };
  hasError: boolean;
  integrationId: ID;
  isPending: boolean;
  isPromoted: boolean;
  promotionDate?: number;
  promotionId: string;
  version: string;
};

function Promotion(props: Props) {
  const {
    error,
    hasError,
    integrationId,
    isPending,
    isPromoted,
    promotionDate,
    promotionId,
    version,
  } = props;

  const shouldRenderErrorCTA = hasError;
  const shouldRenderDoneCTA =
    !hasError &&
    version &&
    isPromoted &&
    promotionDate &&
    differenceInDays(Date.now(), promotionDate) <= 60;
  const shouldRenderProgressCTA = version && !hasError && isPending;

  return (
    <Fragment>
      {shouldRenderErrorCTA && (
        <Error
          error={error}
          integrationId={integrationId}
          type={LifecycleChangeType.promote}
        />
      )}
      {shouldRenderDoneCTA && (
        <Done persistId={promotionId} version={version} />
      )}
      {shouldRenderProgressCTA && <Progress version={version} />}
    </Fragment>
  );
}

export default Promotion;
